/**
 * [1:1] Whether the SOF can be marked complete — the staging area must be
 * non-empty (the server enforces the same rule and returns 400 otherwise).
 *
 * @param stagingArea - The staging-area value from the input.
 * @returns True when a non-blank staging area has been entered.
 */
export function canComplete(stagingArea: string | null | undefined): boolean {
  return !!stagingArea && stagingArea.trim() !== '';
}
